import { Instance } from 'mobx-state-tree';
import { RouteConstraintCapacityDtoModelBase } from './RouteConstraintCapacityDtoModel.base';

/* The TypeScript type of an instance of RouteConstraintCapacityDtoModel */
export interface RouteConstraintCapacityDtoModelType extends Instance<typeof RouteConstraintCapacityDtoModel.Type> {}

/* A graphql query fragment builders for RouteConstraintCapacityDtoModel */
export { selectFromRouteConstraintCapacityDto, routeConstraintCapacityDtoModelPrimitives, RouteConstraintCapacityDtoModelSelector } from './RouteConstraintCapacityDtoModel.base';

/**
 * RouteConstraintCapacityDtoModel
 */
export const RouteConstraintCapacityDtoModel = RouteConstraintCapacityDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
